/**
 * Profile-sidebar insert templates and the registry POSITIONS they read
 * (spec F3 / T3-F).
 *
 * `columns[i]` is sheet column B+i (the Hub drops column A = PHONE). The
 * sidebar sections the registry by POSITION, never by header name — the
 * operators rename headers freely; the positions are the contract with the
 * sheet owner (PR #74). The composed 「插入账号资料」 text must cover exactly
 * the slots the sidebar files under 游戏账号, and the identity card's MEMBER
 * is inserted from its own slot, so those two positions live HERE — one
 * place to change when the sheet owner inserts or deletes a column. The
 * slots only the sidebar reads (K hidden, L..N bank, O 备注, P..Q refer,
 * R+ Other with S = Remark) stay beside it in `ProfileSidebar.tsx`.
 */

/** 游戏账号 = sheet B..I (`columns[0..7]`, both ends inclusive). */
export const GAME_SECTION_RANGE: Readonly<{ start: number; end: number }> = {
  start: 0,
  end: 7,
};

/** Sheet J — the registry MEMBER value. Rendered (and insertable) in the
 *  identity card, never as a section row. */
export const MEMBER_INDEX = 8;

/**
 * The 「插入账号资料」 text: one `COLUMN: VALUE` line per NON-EMPTY 游戏账号
 * slot, in sheet order — the header text verbatim, the value verbatim (no
 * case transform: it is pasted to the customer exactly as stored). `''` when
 * no game slot holds a value, in which case the button is not offered.
 *
 * `valueOf` is the sidebar's own cell lookup, so the composed text and the
 * rows on screen can never disagree about a value.
 */
export function composeAccountInfo(
  columns: readonly string[],
  valueOf: (column: string) => string,
): string {
  const lines: string[] = [];
  const last = Math.min(GAME_SECTION_RANGE.end, columns.length - 1);
  for (let i = GAME_SECTION_RANGE.start; i <= last; i += 1) {
    const value = valueOf(columns[i]);
    if (value !== '') lines.push(`${columns[i]}: ${value}`);
  }
  return lines.join('\n');
}
